module.exports = __webpack_public_path__ + "img/banner.139a2879.png";